module.exports = __webpack_public_path__ + "media/icons/photograph-b1077dac.svg";